export function fmtTimestamp(d: Date): string {
  const p = (n: number): string => String(n).padStart(2, "0");
  const time = `${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfYesterday = new Date(startOfToday.getTime() - 86400000);
  if (d >= startOfToday) return `Heute um ${time}`;
  if (d >= startOfYesterday) return `Gestern um ${time}`;
  const day = `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()}`;
  return `${day} um ${time}`;
}
